import VueTelInputVuetify from './vue-tel-input-vuetify.vue';

export function install(Vue, customOptions = {}) {
  if (install.installed) return;
  install.installed = true;
  Vue.component('VueTelInputVuetify', VueTelInputVuetify);
}

export { VueTelInputVuetify };

const plugin = {
  install
};

// Auto-install
let GlobalVue = null;
if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}
if (GlobalVue) {
  GlobalVue.use(plugin);
}

export default plugin;
